import React, { memo } from 'react';
import styled, { css } from 'styled-components';

interface CardDetailsItemProps {
    hasBackgroundColor: boolean;
    itemLabel: string;
    itemValue: string;
}

export const CardDetailsItem = memo(({ hasBackgroundColor, itemLabel, itemValue }: CardDetailsItemProps) => {
    return (
        <Container hasBackgroundColor={hasBackgroundColor}>
            <Label>
                {itemLabel}
            </Label>
            <Value>
                {itemValue}
            </Value>
        </Container>
    );
});

interface ContainerProps {
    hasBackgroundColor: boolean;
}

const Container = styled.li<ContainerProps>`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 0 15px;
    height: 26px;
    align-items: center;
    ${({ hasBackgroundColor }) => hasBackgroundColor && `
        background-color: #f1f1f1;
    ` }
`;

const DetailListItemStyle = css`
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    justify-content: flex-start;
`;

const Label = styled.div`
    ${DetailListItemStyle}
    color: #aaa;
    width: calc(100% - 60px);
`;

const Value = styled.div`
    ${DetailListItemStyle}
    width: 60px;
    justify-content: flex-end;
`;